import {SagaIterator} from "redux-saga";
import {call, select, takeLatest, getContext} from "redux-saga/effects";
import {Action} from "typescript-fsa";
import {bindAsyncAction} from "typescript-fsa-redux-saga";
import {IceClient} from "@neolab/ice-client";

import {Ganymede} from "@slices/Ganymede/ClientManager";

import {routeSaga} from "src/utils/router";
import {logError} from "src/utils/sagas";
import {RootState} from "src/reducers";

import {
  projectRoute, getClients, createClient,
  createClientSubmitted, createClientToken, generateTokenClicked,
} from "./Project.actions";


const getClientsWorker = bindAsyncAction(getClients)(
  function* getClientsWorker({projectId}): SagaIterator {
    const iceClient: IceClient = yield getContext('iceClient');

    const clientManagerPrx: Ganymede.ClientManagerPrx =
      yield call(iceClient.getProxy, 'ClientManager');

    return yield call(clientManagerPrx.getClients, projectId);
  },
);

const createClientWorker = bindAsyncAction(createClient)(
  function* createClientWorker({projectId, name}): SagaIterator {
    const iceClient: IceClient = yield getContext('iceClient');

    const clientManagerPrx: Ganymede.ClientManagerPrx =
      yield call(iceClient.getProxy, 'ClientManager');

    return yield call(clientManagerPrx.createClient, projectId, name);
  },
);

const createClientTokenWorker = bindAsyncAction(createClientToken)(
  function* createClientTokenWorker({projectId, name}): SagaIterator {
    const iceClient: IceClient = yield getContext('iceClient');

    const clientManagerPrx: Ganymede.ClientManagerPrx =
      yield call(iceClient.getProxy, 'ClientManager');

    const token =
      yield call(clientManagerPrx.createClientToken, projectId, name);

    return {token};
  },
);


const projectSaga = routeSaga(projectRoute)(
  function* projectsSaga(paramsChanged): SagaIterator {
    let projectId: string;

    yield takeLatest(
      paramsChanged as any,
      (action: Action<{id: string}>) => {
        projectId = action.payload.id;

        return getClientsWorker({projectId});
      },
    );

    yield takeLatest(
      createClientSubmitted.type,
      function* submitWorker(): SagaIterator {
        const name = yield select((state: RootState) =>
          state.routes.project.newClientName);

        try {
          yield call(createClientWorker, {projectId, name});
        } catch (e) {
          logError("Failed to create client", e, 'warn');
        }
      },
    );

    yield takeLatest(
      generateTokenClicked.type,
      function* generateWorker(): SagaIterator {
        const client: Ganymede.Client = yield select((state: RootState) => {
          const {clients, selectedClientRow} = state.routes.project;
          return clients![selectedClientRow!];
        });

        const {projectId, name} = client;

        try {
          yield call(createClientTokenWorker, {projectId, name});
        } catch (e) {
          logError("Failed to create client token", e, 'warn');
        }
      },
    );
  },
);

export default projectSaga;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/projects/project/saga.ts